const initialState = {
    aircraftDetails: null,
  };
  
  const aircraftReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_AIRCRAFT_DETAILS":
        return {
          ...state,
          aircraftDetails: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default aircraftReducer;